import { render } from "./ClassDiagramDocument.vue?vue&type=template&id=3f218e65"
import script from "./ClassDiagramDocument.vue?vue&type=script&lang=js"
export * from "./ClassDiagramDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__